import { ButtonNamesGA } from './index';
import {
  AddMenuKeys,
  createPakKeys,
  EcoMenuKeys,
  PakMenuKeys,
  PartsMenuKeysEnum,
  TemplateMenuKeys,
  UserMenuKeys,
} from '../../enums';

export const MenuItemsMappingGA = {
  [createPakKeys.RevisionFromThisPack]: ButtonNamesGA.CreateRevisionFromThisPack,
  [createPakKeys.FromExistingPack]: ButtonNamesGA.CreatePackFromExistingPack,
  [createPakKeys.FromScratch]: ButtonNamesGA.CreatePackFromScratch,
  [createPakKeys.CopyFromThisPack]: ButtonNamesGA.CreateCopyFromThisPack,
  [createPakKeys.SisterPackFromThisPack]: ButtonNamesGA.CreateSisterLocalFromThisPack,
  [createPakKeys.LocalContractFromThisPack]: ButtonNamesGA.CreateSisterLocalFromThisPack,

  [PakMenuKeys.OpenQuote]: ButtonNamesGA.OpenPack,
  [PakMenuKeys.CreateRevision]: ButtonNamesGA.CreateRevisionFromThisPack,
  [PakMenuKeys.CreateCopy]: ButtonNamesGA.CreateCopyFromThisPack,
  [PakMenuKeys.CreateSisterPack]: ButtonNamesGA.CreateSisterLocalFromThisPack,
  [PakMenuKeys.CreateLocalContract]: ButtonNamesGA.CreateSisterLocalFromThisPack,
  [PakMenuKeys.RouteQuote]: ButtonNamesGA.RouteQuote,
  [PakMenuKeys.Properties]: ButtonNamesGA.PackProperties,
  [PakMenuKeys.ArchivePack]: ButtonNamesGA.ArchivePack,
  [PakMenuKeys.UnarchivePack]: ButtonNamesGA.UnarchivePack,
  [PakMenuKeys.MakeContract]: ButtonNamesGA.MakeContract,
  [PakMenuKeys.MakePrototype]: ButtonNamesGA.MakePrototype,
  [PakMenuKeys.AssignAccount]: ButtonNamesGA.AssignAccount,
  [PakMenuKeys.DeleteQuote]: ButtonNamesGA.DeletePack,
  [PakMenuKeys.SendToIrisStaging]: ButtonNamesGA.SendToIrisStaging,
  [PakMenuKeys.ClearInbox]: ButtonNamesGA.ClearFromInbox,
  [PakMenuKeys.RespondToRequest]: ButtonNamesGA.RespondToRequest,
  [PakMenuKeys.TakeOwnership]: ButtonNamesGA.TakeOwnership,
  [PakMenuKeys.GenerateDocument]: ButtonNamesGA.GenerateDocument,
  [PakMenuKeys.ViewRoutingHistory]: ButtonNamesGA.RouteQuote,
  [PakMenuKeys.SaveToSalesforce]: ButtonNamesGA.SaveToSalesforce,
  [PakMenuKeys.TransferOwnership]: ButtonNamesGA.TransferOwnership,

  [TemplateMenuKeys.OpenTemplate]: ButtonNamesGA.OpenTemplate,
  [TemplateMenuKeys.TemplateProperties]: ButtonNamesGA.TemplateProperties,

  [EcoMenuKeys.Edit]: ButtonNamesGA.EditECO,
  [EcoMenuKeys.Export]: ButtonNamesGA.ExportECO,
  [EcoMenuKeys.Execute]: ButtonNamesGA.ExecuteECO,
  [EcoMenuKeys.Preview]: ButtonNamesGA.PreviewECO,
  [EcoMenuKeys.ViewEco]: ButtonNamesGA.ViewECO,
  [EcoMenuKeys.DeleteEco]: ButtonNamesGA.DeleteECO,
  [EcoMenuKeys.ShowResults]: ButtonNamesGA.ShowResults,

  [PartsMenuKeysEnum.ZoomIn]: ButtonNamesGA.ZoomIn,
  [PartsMenuKeysEnum.ZoomOut]: ButtonNamesGA.ZoomOut,
  [PartsMenuKeysEnum.WhereUsed]: ButtonNamesGA.WhereUsed,
  [PartsMenuKeysEnum.DeletePart]: ButtonNamesGA.DeletePart,
  [PartsMenuKeysEnum.ReplacePart]: ButtonNamesGA.ReplacePart,
  [PartsMenuKeysEnum.ChangeLocation]: ButtonNamesGA.ChangePartLocation,
  [PartsMenuKeysEnum.ViewProductPage]: ButtonNamesGA.ViewProductPage,
  [PartsMenuKeysEnum.CompareProduct]: ButtonNamesGA.Compare,
  [AddMenuKeys.AddMenuItems]: ButtonNamesGA.AddItemsToPack,
  [UserMenuKeys.Profile]: ButtonNamesGA.MyProfile,
} as const;
